export class ScrollToBottomModule {
    constructor() {
      
            this.init();
       
    }

    init() {
       
        $(window).on('load', function () {

            var lastSectionText = $('.container-component__section-text').children().last();
            var searchParams = new URLSearchParams(window.location.search);
            var scroll = searchParams.get("scroll");  
            if (scroll == "bottom") {
                $('html, body').animate({
                    scrollTop: $(lastSectionText).offset().top
                });
            }
        });
    }

    
}